// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__17F0y","row":"styles_row__JS2uf"};